import React from "react";
import OnlineStoragePanel from "../show/files/app";
import { type UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";
import { useLoaderData } from "react-router";

const SystemWideFilesApp = () => {
  const viewModel = useLoaderData<server.viewmodel.SystemWideFileListFrontModel>();

  const uploadFiles = (files: File[], uploadConfig: UploadFilesConfig) => {
    return uploadFilesToCoreApi(
      window.CoreApi.File.UploadSystemWideClientFiles,
      window.CoreApi.File.UploadSystemWideClientFiles.absoluteUrl(),
      {
        files
      },
      uploadConfig
    );
  };

  return <OnlineStoragePanel
    config={{
      showVisibleToExternalCheckbox: false,
      displayVisibleToExternalIcon: false,
      canUpload: true,
      perPage: 10,
      itemId: undefined,
      displayPanel: true,
      headerLabel: viewModel.pageTitle
    }}
    standalone
    headerSize="h1"
    uploadFiles={uploadFiles}
    fetchFilesApi={window.CoreApi.File.ListSystemWideClientFiles}
  />;
};

export default SystemWideFilesApp;
